import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalForm } from './ModalForm';
export default function CreateAccountModal(_ref) {
  let trigger = _ref.trigger,
    isOpen = _ref.isOpen,
    handleClose = _ref.handleClose;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const SubmitButton = () => {
    return /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "contained",
      form: "create-account",
      'custom-attribute': '15-create-account-modal'
    }, t('admin_page.create_account'));
  };
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    'custom-attribute': '16-create-account-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('admin_page.add_new_pm_account'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : null,
    trigger: !trigger ? null : defaultTrigger,
    handleClose: handleClose !== null && handleClose !== void 0 ? handleClose : null,
    title: t('admin_page.add_new_pm_account'),
    variant: "middle",
    rightButton: /*#__PURE__*/React.createElement(SubmitButton, null)
  }, /*#__PURE__*/React.createElement(ModalForm, {
    externalTrigger: trigger
  }));
}